module.exports = __webpack_public_path__ + "img/6_73.0d452e6d.png";